<div>
	<button mat-button class="user-list-control" color="primary" title="Users" type="button" (click)="openUserDialog()">
		Users
	</button>
</div>
